'use client';

import ScrollProgressIndicator from '@/components/common/ScrollProgressIndicator';
import SectionAnchorNav from '@/components/common/SectionAnchorNav';
import ConversionFloatingCTA from '@/components/common/ConversionFloatingCTA';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import ProcessTimeline from './ProcessTimeline';
import CaseStudiesSection from './CaseStudiesSection';
import ServicesSection from './ServicesSection';
import FAQSection from './FAQSection';
import AboutSection from './AboutSection';
import FinalCTASection from './FinalCTASection';
import Footer from './Footer';
import { usePathname } from 'next/navigation';
import { Suspense, useEffect } from 'react';

const LandingPageInteractive = () => {
  const handleCTAClick = (type: 'primary' | 'secondary') => {
    const targetId = type === 'primary' ? 'start-mvp' : 'process';
    const element = document.getElementById(targetId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 60,
        behavior: 'smooth',
      });
    }
  };

  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hash = window.location.hash;
    if (!hash) return;

    const id = hash.replace('#', '');
    const element = document.getElementById(id);
    if (!element) return;

    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }, [pathname]);

  return (
    <>
      <ScrollProgressIndicator />
      <SectionAnchorNav scrollOffset={60} />
      <ConversionFloatingCTA scrollOffset={60} />

      <main className="relative z-10 pb-16 lg:pb-0">
        <HeroSection onCTAClick={handleCTAClick} />
        <ProblemSection />
        <ProcessTimeline />
        <Suspense fallback={null}>
          <CaseStudiesSection />
        </Suspense>
        <ServicesSection />
        <FAQSection />
        <AboutSection />
        <FinalCTASection />
        <Footer />
      </main>
    </>
  );
};

export default LandingPageInteractive;
